<template>
  <div class="app-container material-tag">
    <div class="material-tag-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <el-input class="material-tag-filter-value" v-model.trim="filter.tagName" @keyup.enter.native="clickFilterBtn" placeholder="标签名称" clearable size="small" suffix-icon="el-icon-search"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div>
            <el-button class="material-tag-filter-reset" size="small" @click="clickClearBtn">清除条件</el-button>
            <el-button class="material-tag-filter-search" size="small" @click="clickFilterBtn">立即筛选</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <basic-container class="material-tag-container">
      <div class="material-tag-body">
        <div class="material-tag-body-left">
          <div class="material-tag-body-left-type-header header-common">标签分组</div>
          <div>
            <el-menu default-active="0" @select="handleTypeSelect">
              <el-input @keyup.enter.native="clickGroupFilterBtn" 
                        @input="clickGroupFilterBtn" 
                        size="small" placeholder="分组名称" 
                        suffix-icon="el-icon-search" 
                        v-model.trim="groupFilter.groupName">
              </el-input>
              <el-menu-item index="0">
                <span slot="title">全部</span>
              </el-menu-item>
              <el-menu-item v-for="item in materialTagGroup" 
                            :key="item.id"
                            :value="item.id"
                            :index="item.id">
                <span class="group-name" :title="item.groupName" slot="title">{{item.groupName}}</span>
                <el-button class="menu-btn" v-if="material_tag_group_edit" title="编辑" type="text" icon="el-icon-edit" @click="editGroup(item.id,item.groupName)"></el-button>
                <el-button class="menu-btn" v-if="material_tag_group_del" title="删除" type="text" icon="el-icon-delete" @click="deleteGroup(item.id)"></el-button>
              </el-menu-item>
              <el-input class="group-insert" @keyup.enter.native="createMaterialTagGroup" 
                          size="small" placeholder="分组名称" 
                          v-model="addGroupName"
                          ref="groupInput"
                          v-if="createGroupInput">
                </el-input>
                <el-button class="group-insert-btn" v-if="createGroupInput" title="取消" type="text" icon="el-icon-close" @click="createGroupInput = false"></el-button>
                <el-button class="group-insert-btn" v-if="createGroupInput" title="添加" type="text" icon="el-icon-check" @click="createMaterialTagGroup"></el-button>
              <el-button v-if="material_tag_group_add" type="text" size="small" icon="el-icon-plus" @click="addMaterialTagGroup">新增分组</el-button>
            </el-menu>
          </div>
        </div>

        <div class="material-tag-body-right" v-loading="isUploading">
          <div class="material-tag-body-right-header header-common">标签</div>
          <div class="material-tag-body-right-operation">
            <el-button v-if="material_tag_del"
                       type="primary" 
                       size="small" 
                       @click="clickDeleteBtn" 
                       icon="el-icon-delete">删除
            </el-button>
            <el-button v-if="material_tag_add" 
                       type="primary" 
                       size="small" 
                       @click="handleCreate" 
                       icon="el-icon-plus">新增
            </el-button>
          </div>
          <div class="material-tag-body-right-body">
            <avue-crud :table-loading="listLoading" 
                       :data="list" 
                       :option="option"
                       ref="crud"
                       v-model="form" 
                       :page.sync="page"
                       @on-load="onLoad" 
                       @select="handleSelect" 
                       @select-all="handleSelectAll"
                       @row-update="update"
                       @row-save="create">
              <template slot="menu" slot-scope="scope">
                  <el-button v-if="material_tag_edit"
                             size="small"
                             type="text"
                             icon="el-icon-edit"
                             @click="handleUpdate(scope.row,scope.index)">编辑
                  </el-button>
                  <el-button v-if="material_tag_del"
                             size="small"
                             type="text"
                             icon="el-icon-delete"
                             @click="deletes(scope.row,scope.index)">删除
                  </el-button>
              </template>
              <template slot="groupIdForm">
                <el-select v-model="form.groupId" size="medium">
                  <el-option v-for="item in materialTagGroup"
                             :key="item.id"
                             :label="item.groupName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </avue-crud>
          </div>
        </div>
      </div>
    </basic-container>
    <el-dialog title="编辑分组"
               :visible.sync="editGroupDialog"
               width="40%"
               class="handle-dialog">
      <el-form ref="groupFrom" :model="groupFrom" :rules="rules">
        <el-form-item prop="groupName">
          <el-label >分组名称:</el-label>
          <el-input type="text" placeholder="请输入分组名称" v-model="groupFrom.groupName"></el-input>
        </el-form-item>
        <div class="handle-dialog-footer">
          <el-button type="primary" class="handle-dialog-footer-save" @click="editMaterialTagGroup">确定</el-button>
          <el-button class="handle-dialog-footer-cancel" @click="closeDialogHandleGroup">取消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { tableOption } from '@/const/crud/material/tag'
import { getMaterialTagList, deleteMaterialTag, addObj, putObj } from '@/api/material/tag'
import { getMaterialTagGroupList, deleteMaterialTagGroup, addGroupObj, putGroupObj } from '@/api/material/tagGroup'
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      materialTagGroup: [],
      groupProps: {
          label: "groupName",
          value: 'groupName'
      },
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      filter: {
        groupId: '',
        tagName: ''
      },
      groupFilter: {
        groupName: ''
      },
      addGroupName: '',
      listLoading: true,
      isUploading: false,
      createGroupInput: false,
      editGroupDialog: false,
      list: [],
      selectedList: [],
      option:tableOption,
      form: {},
      groupFrom: {
        id: 0,
        groupName:'',
      },
      rules: {
        groupName: [
          {
            required: true,
            message: '分组名称不能为空',
            trigger: 'blur'
          },{
            max: 32,
            message: '分组名称长度不能超过32',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  computed: {
      ...mapGetters(["permissions"])
  },
  created() {
    this.loadMaterialTagGroup();
    this.material_tag_add = this.permissions["material_tag_add"];
    this.material_tag_del = this.permissions["material_tag_del"];
    this.material_tag_edit = this.permissions["material_tag_edit"];
    this.material_tag_group_add = this.permissions["material_tag_group_add"];
    this.material_tag_group_del = this.permissions["material_tag_group_del"];
    this.material_tag_group_edit = this.permissions["material_tag_group_edit"];
    
  },
  methods: {
    async loadMaterialTagGroup(){
      const params = {};
      params.groupName = this.groupFilter.groupName;
      const response = await getMaterialTagGroupList(params);
      this.materialTagGroup = response.data.data;
    },
    async basicGetMaterialTagList() {
      this.listLoading = true;
      const params = {};
      params.size = this.page.pageSize;
      params.current = this.page.currentPage;
      params.groupId = this.filter.groupId;
      params.tagName = this.filter.tagName;
      const response = await getMaterialTagList(params);
      this.list = response.data.data.records;
      this.list.forEach(item => {
        item.checked = false;
      });
      this.page.total = response.data.data.total;
      this.listLoading = false;
    },
    onLoad(page) {
      this.page.pageSize = page.pageSize;
      this.page.currentPage = page.currentPage;
      this.basicGetMaterialTagList(page);
    },
    handleSelect (selection, row) {
      this.selectedList = selection;
    },
    handleSelectAll (selection) {
      this.selectedList = selection;
    },
    editGroup(id,groupName) {
      this.editGroupDialog = true,
      this.groupFrom.groupName = groupName;
      this.groupFrom.id = id;
    },
    editMaterialTagGroup() {
      this.$refs.groupFrom.validate((valid) => {
        if (!valid) return;
        const params = {};
        params.id = this.groupFrom.id;
        params.groupName = this.groupFrom.groupName;
        putGroupObj(params).then(() => {
          this.loadMaterialTagGroup();
          this.editGroupDialog = false;
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success',
            duration: 2000
          })
        })
      })
    },
    closeDialogHandleGroup() {
      this.editGroupDialog = false;
      this.$refs.groupFrom.clearValidate();
    },
    deleteGroup(id) {
      this.$confirm('此操作将删除该分组, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteMaterialTagGroup(id);
        this.$message.success('删除成功');
        this.loadMaterialTagGroup();
      });
    },
    addMaterialTagGroup() {
      this.createGroupInput = !this.createGroupInput;
    },
    createMaterialTagGroup(){
      const params = {};
      params.groupName = this.addGroupName;
      addGroupObj(params).then(() => {
        this.loadMaterialTagGroup();
        this.createGroupInput = false;
        this.addGroupName = '';
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        })
      })
    },
    handleCreate() {
      this.$refs.crud.rowAdd();
    },
    create(row, done, loading) {
      addObj(this.form).then(() => {
        this.basicGetMaterialTagList();
        done();
        this.$notify({
          title: '成功',
          message: '创建成功',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        loading();
      });
    },
    handleUpdate(row, index) {
      if(row.groupId == -1) {
        row.groupId = '';
      }
      this.$refs.crud.rowEdit(row, index);
    },
    update(row, index, done, loading) {
      putObj(this.form).then(() => {
        this.basicGetMaterialTagList();
        done();
        this.$notify({
          title: '成功',
          message: '更新成功',
          type: 'success',
          duration: 2000
        })
      }).catch(() => {
        loading();
      });
    },
    clickDeleteBtn () {
      if (this.selectedList.length === 0) {
        this.$message.info('您还没有选择要删除的标签');
        return;
      }
      this.$confirm('此操作将删除这些标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const ids = this.selectedList.map(item => item.id);
        await deleteMaterialTag(ids.join(','));
        this.$message.success('删除成功');
        this.selectedList = [];
        this.page.currentPage = 1;
        this.basicGetMaterialTagList();
      });
    },
    deletes(row,index) {
      this.$confirm('此操作将删除该标签, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await deleteMaterialTag(row.id);
        this.$message.success('删除成功');
        this.page.currentPage = 1;
        this.basicGetMaterialTagList();
      });
    },
    handleTypeSelect (index) {
      const searchType = (index === '0' ? null : index);
      if (searchType === this.filter.groupId) {
        return;
      }
      this.filter.groupId = searchType;
      this.filter.tagName = '';
      this.page.currentPage = 1;
      this.basicGetMaterialTagList();
    },
    clickClearBtn () {
      this.filter.tagName = '';
      this.page.currentPage = 1;
      this.basicGetMaterialTagList();
    },
    clickFilterBtn () {
      this.page.currentPage = 1;
      this.basicGetMaterialTagList();
    },
    clickGroupFilterBtn () {
      this.loadMaterialTagGroup();
    },
  }
}
</script>

<style lang="scss" scoped>
.material-tag {
  &-filter {
    margin: 0 10px;
    /deep/ .el-input__inner {
      border: none;
      font-size: 14px;
    }
    .el-row {
      width: 95%;
    }
    &-value {
      width: calc(100% - 12px) !important;
    }
    &-reset {
      margin-left: 10px;
    }
    &-search {
      margin-left: 10px;
      border-color: #5383f3;
      color: #5383f3;
    }
  }

  &-container {
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 170px;
      text-align: left;
    }
  }
}
.material-tag-header {
  display: flex;
  justify-content: space-between;
  padding: 0 10px;
  &-filter {
    display: flex;
    justify-content: space-between;

    .el-button+ .el-button {
      margin: 0px;
    }
    &-search {
      margin-left: 8px;
      border-color: #5383f3;
      color: #5383f3;
    }
    &-reset {
      margin-left: 20px;
      margin-right: 8px;
    }
  }
}
 ::v-deep.el-menu {
    background-color: transparent;
    .el-menu-item {
      color: #3b3b3b;
      height: 40px;
      border-radius: 4px;
      line-height: 40px;
    }
    .el-menu-item:focus,
    .el-menu-item:hover {
      color: #409EFF;
      .menu-btn {
        visibility: visible;
      }
    }
    .menu-btn {
      margin: 0;
      padding: 0;
      visibility: hidden;
      float: right;
      padding-top: 10px;
    }
 }
.material-tag-body {
  margin-top: 8px;
  display: flex;
  .header-common {
    padding-left: 10px;
    line-height: 50px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #3b3b3b;
  }
  &-left {
    flex: 2;
    .group-name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      width: 90px;
    }
    .group-insert {
      width: 140px;
    }
    .group-insert-btn {
      color: #3b3b3b;
      font-size: 17px;
      margin: 2px;
      padding: 0;
      float: right;
      padding-top: 3px;
    }
  }
  &-right {
    flex: 8;
    padding-left: 20px;
    &-body {
      /deep/ .avue-crud {
        margin: 0 0;
        .avue-crud__menu {
          display: none;
        }
        .avue-crud__box .el-card__body,
        .avue-crud__box .el-card__header {
          padding-top: 0;
        }
        .avue-crud__tip {
          display: none;
        }
      }
      .material-name {
        display: flex;
        align-items: center;
        padding: 8px 0;
        span {
          white-space: nowrap;
        }
      }
      .row-operation {
        display: flex;
        .row-menu {
          display: flex;
          align-items: center;
          font-size: 12px;
          border: none;
          color: #409EFF;
          background: transparent;
          i {
            width: 13px;
            height: 13px;
            margin-right: 2px;
          }
        }
      }
    }
  }
}
.handle-dialog {
  display: flex;
  flex-direction: column;
  &-footer{
    display: flex;
    flex-direction: row;
    padding: 50px 0px;
    &-save {
      padding: 8px 12px;
      position: absolute;
      right: 90px;
    }
    &-cancel {
      padding: 8px 12px;
      position: absolute;
      right: 10px;
      margin-right: 10px;
    }
  }
}
</style>
